import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorCompanyService, ConfiguratorProviderService, SelectItem} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-client',
    templateUrl: './select-client.component.html',
    styleUrls: ['./select-client.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectClientComponent
        }
    ],
    standalone: false
})
export class SelectClientComponent implements OnChanges, ControlValueAccessor {

    constructor(private configuratorProviderService: ConfiguratorProviderService,
                private configuratorCompanyService: ConfiguratorCompanyService) {
    }

    provider: SelectItem;
    list: SelectItem[];

    @Input() datastore: string;
    @Input() value: string;
    @Output() change = new EventEmitter<SelectItem>();
    @Input() disabled = false;
    @Input() cache: false;
    touched = false;

    onChange = (value) => {
    };
    onTouched = () => {
    };

    private loadProvider() {
        if (this.datastore?.length > 0) {
            this.configuratorCompanyService.getAllCompaniesUsingGET(this.datastore, null).subscribe(res => {
                this.list = [];
                res.forEach(item => {
                    this.list.push({
                        value: item.id,
                        label: item.name
                    });
                });
            });
        }
    }

    writeValue(codeProvider: any): void {
        this.value = codeProvider;
        this.updateValue();
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.updateValue();
        }
        if (changes.datastore && this.datastore != null) {
            this.loadProvider();
        }
    }

    private updateValue() {
        if (this.list == null) {
            return;
        }
        if (this.value) {
            this.provider = this.list.find(d => d.value == this.value);
            return;
        }
        this.providerChange();
    }

    providerChange() {
        if (this.provider != null && !this.disabled) {
            this.onChange((this.provider as SelectItem).value);
            this.markAsTouched();
            this.change.emit(this.provider);
        }
    }

}
